import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import SignUp from "../Authentication/SignUp";
import DashboardLayout from "../layout/DashboardLayout";
import FileUploadAndProcessForm from "../components/DataUpload/FileUploadAndProcessForm";
import DataReviewAndConfigure from "../components/DataHistory/DataReviewAndConfigure";
import WelcomeDashboard from "../components/Dashboard/WelcomeDashboard";
import Login from "../Authentication/Login";
import ForgotPassword from "../Authentication/ForgotPassword";
import EmailVerificationPage from "../Authentication/EmailVerificationPage";
import PhoneVerificationPage from "../Authentication/PhoneVerificationPage";

// function PrivateRoute({ children }) {
//   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
//   // console.log("isLoggedIn:", isLoggedIn);
//   return isLoggedIn ? children : <Navigate to="/login" replace />;
// }

function PrivateRoute({ children }) {
  const location = useLocation();
  const { isLoggedIn, accessToken, refreshToken } = useSelector((state) => state.auth);
  const isAuthorized = Boolean(isLoggedIn && (accessToken || refreshToken));

  return isAuthorized
  ? children
  : <Navigate to="/login" replace state={{ from: location }} />;
}

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public */}
      <Route index element={<Navigate to="/login" replace />} />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<EmailVerificationPage />} />
      <Route path="/verify-phone" element={<PhoneVerificationPage />} />

      {/* Protected layout with nested routes */}
      <Route
        path="/dashboard/*"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        {/* index = /dashboard */}
        <Route index element={<WelcomeDashboard />} />
        {/* /dashboard/data-entry */}
        <Route path="data-entry" element={<FileUploadAndProcessForm />} />
        {/* /dashboard/upload-result */}
        <Route path="upload-result" element={<DataReviewAndConfigure />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<div className="p-6">Page not found</div>} />
    </Routes>
  );
};

export default AppRoutes;
